import React, { useState, useEffect } from 'react';
import { Button, Icon, message } from 'antd';
import {
  UserDetailHeadingCover,
  LoaderContainer,
  StorageCards,
  StorageHead,
  StorageButton,
  StorageCardContainer,
  LineSeparator,
  ResourceSelector,
  ImageIconWrapper,
  ServicesCards,
  StorageConfirmationModal,
} from './styles';
import Loader from '../../components/Loader';

import googleIcon from '../../images/google-icon.svg';
import awsIcon from '../../images/aws-logo.png';
import dropBoxIcon from '../../images/dropbox-icon.svg';
import azureIcon from '../../images/azure-logo.png';
import localIcon from '../../images/local-icon.svg';

import StorageModal from '../../components/Modals/StorageModal';

import { listofServices, postServicedata } from '../../utils/services/storageAPI';
import { withTranslation } from 'react-i18next';
import { MANAGE_MULTI_CLOUD_STORAGE_SETTINGS as trans } from './TranslationValues';
import ServiceDetailsModal from '../../components/Modals/ServiceDetailsModal';

const NAMESPACE = ['MANAGE_MULTI_CLOUD_STORAGE_SETTINGS'];
const MulticloudSettings = props => {
  const { t } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [resource, setResource] = useState({});
  const [services, setServices] = useState([]);
  const [modalVisibility, setmodalVisibility] = useState(false);
  const [selectedService, setselectedService] = useState(null);
  const [allFields, setAllFields] = useState(null);
  const [editType, setEditType] = useState(null);
  const [enableSwitch, setEnableSwitch] = useState({});
  const [chosenService, setChosenService] = useState(null);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(null);
  const [awaitingApiResponse, setAwaitingApiResponse] = useState(false);

  const servicesList = [
    { name: 'azure', icon: azureIcon, label: 'Azure' },
    { name: 'aws', icon: awsIcon, label: 'Amazon Web Services' },
    { name: 'google', icon: googleIcon, label: 'Google' },
    { name: 'dropBox', icon: dropBoxIcon, label: 'Dropbox' },
    { name: 'local', icon: localIcon, label: t(trans.LOCAL_LABEL.key, trans.LOCAL_LABEL.value) },
  ];

  // display the default service first.
  const compareServices = (a, b) => {
    if (a.credentials === 'default') {
      return -1;
    }
    if (b.credentials === 'default') {
      return 1;
    }
    return 0;
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await listofServices();
        if (response?.statusCode === 107) {
          const sortedServices = response.data.services.sort(compareServices);
          setServices(sortedServices);
          setResource(response.data.resources);
        } else {
          message.error(t(trans.STORAGE_DATA_FETCH_FAIL_ERROR.key, trans.STORAGE_DATA_FETCH_FAIL_ERROR.value));
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const enableModalVisibility = (serviceName, type) => {
    setselectedService(serviceName);
    setEditType(type);
    setmodalVisibility(true);
  };

  const disableModalVisibility = data => {
    setmodalVisibility(false);
    if (data) {
      if (editType === 'services') {
        allFields[selectedService] = data;
        let statusSwitch = JSON.parse(JSON.stringify(enableSwitch));
        statusSwitch[selectedService] = Object.values(data).every(data => {
          return data !== '';
        });
        setEnableSwitch(statusSwitch);
      } else {
        setResource(data);
      }
    }
  };

  const isVisibleResources = Object.values(enableSwitch).some(data => {
    return data === true;
  });

  const getConfiguredServiceList = data => {
    let serviceList = Object.keys(data).filter(function(key) {
      return data[key];
    });
    return serviceList;
  };

  const resourceEditHandler = (serviceName, type) => {
    enableModalVisibility(serviceName, type);
  };

  const handleIconSelect = type => {
    switch (type) {
      case 'google':
        return googleIcon;
      case 'aws':
        return awsIcon;
      case 'azure':
        return azureIcon;
      case 'dropBox':
        return dropBoxIcon;
      case 'local':
        return localIcon;
      default:
        break;
    }
  };

  const handleServiceSelection = item => {
    setIsConfirmModalVisible(item);
  };

  const renderServiceCard = (item, logo, serviceName) => {
    return (
      <ServicesCards
        onClick={() => !item.storageConfigured && handleServiceSelection(item)}
        className={item.storageConfigured && 'active-card'}
      >
        <div>
          <img src={logo} alt="icons" />
          <p>{serviceName}</p>
        </div>
        <div>
          {item.credentials === 'default' ? (
            <div>
              <p className="default-label">{t(trans.DEFAULT_LABEL.key, trans.DEFAULT_LABEL.value)}</p>
            </div>
          ) : (
            item.storageConfigured && (
              <StorageButton
                onClick={e => {
                  e.stopPropagation();
                  setChosenService(item);
                }}
              >
                <Icon type="setting" />{' '}
                {t(
                  trans.CONFIGURE_MULTI_CLOUD_STORAGE_SETTINGS_BUTTON.key,
                  trans.CONFIGURE_MULTI_CLOUD_STORAGE_SETTINGS_BUTTON.value,
                )}
              </StorageButton>
            )
          )}
        </div>
      </ServicesCards>
    );
  };

  const handleAddUpdateService = async (payload, update = false) => {
    setAwaitingApiResponse(true);
    try {
      delete payload.storageConfigured;
      const response = await postServicedata(payload);
      if (response?.statusCode === 105) {
        const data = services.map(item => {
          if (item.name === payload.name) {
            return { ...item, storageConfigured: true };
          }
          return { ...item, storageConfigured: false };
        });
        setServices(data);
        setChosenService(null);
        update && message.success(t(trans.STORAGE_CONFIG_UPDATE_SUCCESS_MESSAGE.key, trans.STORAGE_CONFIG_UPDATE_SUCCESS_MESSAGE.value));
      } else {
        message.error(t(trans.STORAGE_CONFIG_UPDATE_ERROR_MESSAGE.key, trans.STORAGE_CONFIG_UPDATE_ERROR_MESSAGE.value));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setAwaitingApiResponse(false);
    }    
  };

  const handleConfirmSelection = async service => {
    const newService = Object.values(service.credentials).every(value => value === null);
    if (newService) {
      setChosenService(service);
    } else {
      await handleAddUpdateService(service);
    }
    setIsConfirmModalVisible(null);
  };

  const renderResourcesCard = (logo, resourceName, title) => {
    return (
      <StorageCards resourceCard>
        <div className="card-head">
          <div>
            <Icon type={logo} style={{ fontSize: '20px' }} />
            <p>{title}</p>
          </div>
        </div>
        <p className="description">
          {t(
            trans.RESOURCE_CONFIGURATION_DESCRIPTION_LABEL.key,
            trans.RESOURCE_CONFIGURATION_DESCRIPTION_LABEL.value,
          )}
        </p>
        <ResourceSelector onClick={() => resourceEditHandler(resourceName, 'resources')}>
          <div>
            <ImageIconWrapper>
              <img src={handleIconSelect(resource[resourceName].service)} alt="icons" />
            </ImageIconWrapper>
            <p>{resource[resourceName].service}</p>
          </div>
          <Icon type="right" style={{ fontSize: '13px' }} />
        </ResourceSelector>
      </StorageCards>
    );
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <div style={{ paddingBottom: '2rem' }}>
          <UserDetailHeadingCover separator>
            <div>
              <h5>
                {t(
                  trans.MANAGE_MULTI_CLOUD_STORAGE_SETTINGS_TITLE.key,
                  trans.MANAGE_MULTI_CLOUD_STORAGE_SETTINGS_TITLE.value,
                )}
              </h5>
              <p>
                {t(
                  trans.MANAGE_MULTI_CLOUD_STORAGE_SETTINGS_DESCRIPTION.key,
                  trans.MANAGE_MULTI_CLOUD_STORAGE_SETTINGS_DESCRIPTION.value,
                )}
              </p>
            </div>
          </UserDetailHeadingCover>
          <LineSeparator></LineSeparator>
          <StorageHead>
            {t(
              trans.EXPLORE_MULTI_CLOUD_STORAGE_SERVICES_LABEL.key,
              trans.EXPLORE_MULTI_CLOUD_STORAGE_SERVICES_LABEL.value,
            )}
          </StorageHead>
          <StorageCardContainer isStorageCards>
            {services.map(item => {
              return renderServiceCard(
                item,
                servicesList.find(service => service.name === item.name)?.icon || localIcon,
                servicesList.find(service => service.name === item.name)?.label || item.name,
              );
            })}
          </StorageCardContainer>
          <LineSeparator></LineSeparator>
          {isVisibleResources && (
            <>
              <StorageHead>
                {t(
                  trans.MULTI_CLOUD_STORAGE_RESOURCES_LABEL.key,
                  trans.MULTI_CLOUD_STORAGE_RESOURCES_LABEL.value,
                )}
              </StorageHead>
              <StorageCardContainer>
                {renderResourcesCard('picture', 'images', t(trans.RESOURCE_IMAGE_TITLE.key, trans.RESOURCE_IMAGE_TITLE.value))}
                {renderResourcesCard('layout', 'templateResources', t(trans.RESOURCE_TEMPLATE_TITLE.key, trans.RESOURCE_TEMPLATE_TITLE.value))}
                {renderResourcesCard('font-size', 'fonts', t(trans.RESOURCE_FONTS_TITLE.key, trans.RESOURCE_FONTS_TITLE.value))}
                {renderResourcesCard('file-pdf', 'processedPDF', t(trans.RESOURCE_PROCESSED_FONTS_TITLE.key, trans.RESOURCE_PROCESSED_FONTS_TITLE.value))}
                {renderResourcesCard('file-image', 'thumbNails', t(trans.RESOURCE_THUMBNAILS_TITLE.key, trans.RESOURCE_THUMBNAILS_TITLE.value))}
              </StorageCardContainer>
            </>
          )}
        </div>
      )}
      {isConfirmModalVisible && (
        <StorageConfirmationModal
          visible={isConfirmModalVisible}
          closable={false}
          footer={[
            <Button onClick={() => setIsConfirmModalVisible(null)}>{t(trans.CANCEL_BUTTON.key, trans.CANCEL_BUTTON.value)}</Button>,
            <Button
              loading={awaitingApiResponse}
              onClick={() => {
                handleConfirmSelection(isConfirmModalVisible);
              }}
            >
              {t(trans.YES_CONFIRMATION_BUTTON.key, trans.YES_CONFIRMATION_BUTTON.value)}
            </Button>,
          ]}
        >
          <p>{t(trans.SWITCH_CONFIG_CONFIRMATION_MESSAGE.key, trans.SWITCH_CONFIG_CONFIRMATION_MESSAGE.value)}</p>
        </StorageConfirmationModal>
      )}
      {chosenService && (
        <ServiceDetailsModal
          selectedService={chosenService}
          servicesList={servicesList}
          onCancel={() => setChosenService(null)}
          handleAddUpdateService={handleAddUpdateService}
          awaitingApiResponse={awaitingApiResponse}
        />
      )}
      {modalVisibility && (
        <StorageModal
          visible={modalVisibility}
          onCancel={disableModalVisibility}
          selectedService={selectedService}
          editType={editType}
          targetForm={allFields[selectedService]}
          resourceData={resource}
          configuredServices={getConfiguredServiceList(enableSwitch)}
        />
      )}
    </React.Fragment>
  );
};

export default withTranslation(NAMESPACE)(MulticloudSettings);
